import RotatingText from 'react-rotating-text';
import './rotatingtextanimation.css';

const RotatingTextAnimation = () => {
    return (
        <>
            <RotatingText 
                emptyPause={1000}
                typingInterval={50}
                deletingInterval={20}
                pause={1000}
                cursor={{ blink: true, char: '|', blinkInterval: 500 }}
                items={['Bats', 'Termites', 'Rodents', 'Bed Bugs', 'Mosquitoes', 'Ants', 'Spiders', 'Fleas', 'Centipedes', 'Wasps', 'Mice','Flies', 'Lizards', 'Snakes', 'Moths', 'Silverfish', 'Scorpions', 'Centipedes', 'Earwig', 'Cicada Killer', 'Cockroaches', 'Crickets','Fire Ants','Fruit Flies','Maggots', 'Moths', 'Mosquitoes']} 
            />       
        </>
    )
}

export default RotatingTextAnimation